export enum EntitiesTypes {
  GET_ENTITIES_BY_TYPE = '@@POcomparison/GET_ENTITIES_BY_TYPE',
  GET_ENTITIES_BY_TYPE_SUCCESS = '@@purchaseOrders/GET_ENTITIES_BY_TYPE_SUCCESS',
  GET_ENTITIES_BY_TYPE_FAIL = '@@POcomparison/GET_ENTITIES_BY_TYPE_FAIL',

  GET_ENTITIES_LIST = '@@entities/GET_ENTITIES_LIST',
  GET_ENTITIES_LIST_SUCCESS = '@@entities/GET_ENTITIES_LIST_SUCCESS',
  GET_ENTITIES_LIST_FAIL = '@@entities/GET_ENTITIES_LIST_FAIL',

  GET_ENTITY = '@@entities/GET_ENTITY',
  GET_ENTITY_SUCCESS = '@@entities/GET_ENTITY_SUCCESS',
  GET_ENTITY_FAIL = '@@entities/GET_ENTITY_FAIL',
  GET_ENTITY_RESET = '@@entities/GET_ENTITY_RESET',
}
